export const EMBED_MODE = Object.freeze({
	EDIT: 'edit',
	NONE: 'none',
	PREVIEW: 'preview',
} as const);

export type TEmbedMode = typeof EMBED_MODE[keyof typeof EMBED_MODE];
